import { browserSessionStore } from '@tassat/utility';

import { getAuthConfiguration } from 'config/variables';

// eslint-disable-next-line import/no-cycle
import authService from '../auth/AuthService';
import authServiceMap from '../auth/authServiceMap';
import browserHistory from '../browserHistory';

/* eslint-disable no-console */
const getBasePath = ({ pathname }) => (pathname.substring(0, pathname.lastIndexOf('/') + 1));
const getOrigin = ({ location: { origin, pathname }}) => (`${origin}${getBasePath({ pathname })}`);

function handleResponse(response, store, listener) {
    const command = response.command;
    listener.resolve(response);
    switch (command.method) {
        case 'getCollateral':
            if (response.data.CollateralHistoryViewRecords) {
                store.dispatch({
                    type: 'SET_PLEDGES',
                    payload: response.data.CollateralHistoryViewRecords
                });
            }
            break;
        case 'getCollateralDetail':
            if (response.data.CollateralHistoryDetailRecords?.length) {
                store.dispatch({
                    type: 'SET_PLEDGE_DETAIL',
                    payload: response.data.CollateralHistoryDetailRecords[0]
                });
            }
            break;
        case 'getTransactions':
            if (response.data.transactions) {
                store.dispatch({
                    type: 'SET_TRANSACTIONS',
                    payload: response.data.transactions
                });
            }
            break;
        case 'getTransactionDetail': {
            const tx = response.data.transactions?.[0];
            if (tx) {
                store.dispatch({
                    type: 'Transaction',
                    payload: tx
                });
            }
            break;
        }
        case 'getPendingTransactions':
            if (response.data.transactions) {
                store.dispatch({
                    type: 'SET_PENDING_TRANSACTIONS',
                    payload: response.data.transactions
                });
            }
            break;
        case 'getBankSettlementInstructions':
            if (response.data.settlementinstructions) {
                store.dispatch({
                    type: 'SET_SETTLEMENT_INSTRUCTIONS',
                    payload: response.data.settlementinstructions
                });
            }
            break;
        case 'getUsers':
            if (response.data.users) {
                store.dispatch({
                    type: 'SET_USERS',
                    payload: response.data.users
                });
            }
            break;
        case 'getFirmActivity':
            if (response.data.activities) {
                store.dispatch({
                    type: 'SET_FIRM_ACTIVITY',
                    payload: response.data.activities
                });
            }
            break;
        case 'getUserActivity':
            if (response.data.activities) {
                store.dispatch({
                    type: 'SET_USER_ACTIVITY',
                    payload: response.data.activities
                });
            }
            break;
        case 'getAlerts':
            if (response.data) {
                store.dispatch({
                    type: 'SET_ALERTS',
                    payload: response.data.alerts
                });
            }
            break;
        case 'getClientMessages':
            if (response.data) {
                store.dispatch({
                    type: 'SET_CLIENT_MESSAGES',
                    payload: response.data.clientmessages
                });
            }
            break;
        case 'getAllUserRoles':
            if (response.data) {
                const userId = browserSessionStore.getItem('userid');
                const userObj = store.getState().users[userId];
                const userRole = response.data.userroles.find(r => r.AdminRoleId === userObj?.AdminRoleId);
                store.dispatch({ type: 'ui-state/setUserRole', payload: userRole });
                store.dispatch({ type: 'ui-state/setUserRoles', payload: response.data.userroles });
            }
            break;
        case 'getAddressBookContacts':
            if (response.data) {
                store.dispatch({
                    type: 'SET_CONTACTS',
                    payload: response.data
                });
            }
            break;
        case 'getFirmByWalletAddress':
        case 'getFeeByOrderDetails':
        case 'getWalletAddressDetails':
        case 'checkUniqueUsername':
        case 'validateWithdrawalInstructionDescription':
        case 'validateBeneAddress':
        case 'getLinkedRequestId':
        case 'getRecurringPaymentDates':
        case 'setSocketRole':
        case 'getAccountHasCollateralRecords':
            //Do nothing, used for form validation and no redux updates needed
            break;
        default:
            console.debug(`Dispatching ${response.data.Msg}`);
            if (!response.data.Msg) {
                console.error('Received unexpected message', response.data);
            }

            if (response.data.Msg) {
                store.dispatch({
                    type: response.data.Msg,
                    payload: response.data
                });
            }
            break;
    }
}

export default function (worker, listener, store) {
    return async (event) => {
        const { type, response } = event.data;
        switch (type) {
            case 'connected':
                worker.postMessage({
                    type: 'startSession',
                    data: { origin: getOrigin(window) }
                });
                break;
            case 'response':
                handleResponse(event.data, store, listener);
                break;
            case 'data':
                // console.debug('MSG', event);
                if (event.data.response.Msg === 'CustomerLogout') {
                    console.log('Logging out user');
                    authService.logout();
                } else if (event.data.response.Msg === 'UserRecord') {
                    const appStore = store.getState();
                    // Only redirect to ToS if this is not an admin user, if they haven't accept ToS
                    // and if its the user record for the same user id
                    if (!event.data.response.IsTermsOfServiceApproved &&
                        !event.data.response.IsAdmin &&
                        (event.data.response.UserId === browserSessionStore.getItem('userid'))) {
                        browserHistory.replace('/tos');
                    }
                    store.dispatch({
                        type: event.data.response.Msg,
                        payload: event.data.response
                    });
                } else if (event.data.response.RequestPattern === 'heartbeat') {
                    listener.createHeartbeat();
                } else if (event.data.response.Msg === 'TokenExpiration') {
                    const renewAccessToken = async () => {
                        const authConfig = await getAuthConfiguration();
                        const loginMethod = authConfig?.AUTH_THEMES_CONFIG?.LoginMethod;

                        try {
                            const authService = await authServiceMap[loginMethod]();

                            if (authService) {
                                await authService.refreshToken(listener);
                            } else {
                                console.error(`AuthService not found for login method: ${loginMethod}`);
                            }
                        } catch (error) {
                            console.error('Refresh token during handling of `TokenExpiration` message failed - ', error);
                            authService.logout();
                        }
                    };

                    renewAccessToken();
                } else if (event.data.response.Msg === 'ReconnectCustomer') {
                    // placeholder for Reconnect Customer workflow
                } else if (event.data.response.Msg === 'DisconnectedFromCore') {
                    // placeholder for Disconnected Server workflow
                } else if (event.data.response.Msg) {
                    store.dispatch({
                        type: event.data.response.Msg,
                        payload: event.data.response
                    });
                }
                break;
            default:
                console.log('Unknown RT message', event, type, response);
                break;
        }
    };
}